import React from 'react';
import './ConversationListSkeleton.css';

const ConversationListSkeleton = ({ count = 8 }) => {
  // Generate varying widths for more realistic look
  const generateWidths = () => {
    return Array.from({ length: count }).map((_, i) => {
      const widths = [
        [65, 40],
        [80, 35],
        [70, 50, 25],
        [60, 45],
        [75, 30],
        [55, 50, 20],
        [70, 40],
        [85, 25],
      ];
      return widths[i % widths.length];
    });
  };

  const itemWidths = generateWidths();

  return (
    <div className="conversation-list-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-conversation-item">
          <div className="skeleton-conversation-avatar" />
          <div className="skeleton-conversation-content">
            <div className="skeleton-conversation-name" style={{ width: `${itemWidths[i][0]}%` }} />
            <div className="skeleton-conversation-preview">
              {itemWidths[i].slice(1).map((width, j) => (
                <div key={j} className="skeleton-conversation-line" style={{ width: `${width}%` }} />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConversationListSkeleton;
